// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("GlobalChatMessage", {
  id: __t.u64(),
  userId: __t.u64(),
  username: __t.string(),
  countryCode: __t.string(),
  message: __t.string(),
  createdAt: __t.u64(),
  vipTier: __t.u32(),
});


